import Cookies from 'js-cookie';
import $ from 'jquery';
import config from '../config';
import {buildRedirectUrlToLoginPage, getCurrentDomainObj} from './utils';

const isAuthEndpoint = (url) => {
  if (!url) return false;
  return url.includes('/auth/refresh-token') ||
         url.includes('/auth/ping') ||
         (url.includes('/auth') && !url.includes('/auth/'));
};

const refreshTokens = () => {
  const result = $.ajax({
    method: 'POST',
    alwaysAllowed: true,
    refreshRetry: true,
    async : false,
    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
    headers: {
      Authorization: Cookies.get('__auth', getCurrentDomainObj())
    },
    url: `${config.apiUrl}/auth/refresh-token`,
    xhrFields: {
      withCredentials: true
    }
  }).fail(error => {
    Cookies.remove('__auth', getCurrentDomainObj());
    window.location.href = buildRedirectUrlToLoginPage();
  });
  return result;
}

export const setupAjaxInterceptor = () => {
  $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    let payload = ''
    let tokenData = {}

    if (isAuthEndpoint(options.url)) {
      return;
    }

    const accessToken = Cookies.get('__auth', getCurrentDomainObj());
    if (accessToken) {
      try {
        payload = accessToken.split('.')[1]
        if (payload) {
          tokenData = JSON.parse(atob(payload))
        }
      } catch (error) {
        window.location.href = buildRedirectUrlToLoginPage();
      }

      if (!tokenData) {
        return;
      }

      const tokenExpDate = tokenData.exp || 0;
      const accessTokenExpDate = Math.floor(tokenExpDate / 1000);

      const nowTime = Math.floor(new Date().getTime() / 1000)

      const isAccessTokenExpired = (nowTime - accessTokenExpDate) > 0;

      if (isAccessTokenExpired) {
        const newTokenData = refreshTokens();

        const authorization = `Bearer${newTokenData.responseJSON.access_token}`;
        Cookies.remove('__auth', getCurrentDomainObj());
        Cookies.set('__auth', authorization, getCurrentDomainObj());
      }
    }
    return jqXHR;
  });
};
